// Here we can add more languages that should NOT have titlecase on the navigation item names
export const excludeLangFromTitleCase = ['es'];